// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-fC-pYPoM","foot_link":"foot_link-3TPP4X4X","list":"list-3hoJnHb6","link":"link-1BpzV_oy","copyright":"copyright-wpWOIDgW"};